module.exports = __webpack_public_path__ + "static/media/tulip.575b52a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile-icons/tulip.svg
// module id = 1115
// module chunks = 31